import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Button from '@strava/ui/Button';
import { csrfToken } from 'utils/networking-client';

import I18n from 'utils/I18n';
import Modal from '@strava/ui/Modal';

import styles from './styles.scss';

const CorrectDistance = ({ activityId, activeSource }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const toggleModalOpen = () => {
    setIsModalOpen(!isModalOpen);
  };

  const modalContents =
    activeSource === 'device' ? (
      <div className={styles.modalContents}>
        {I18n.t_html('templates.activities.distance_correction.synthetic_html')}

        <Button
          type="submit"
          className={styles.correctButton}
          variant="primary"
        >
          {I18n.t('templates.activities.distance_correction.correct_distance')}
        </Button>
      </div>
    ) : (
      <div className={styles.modalContents}>
        {I18n.t_html(
          'templates.activities.distance_correction.synthetic_revert_html'
        )}

        <Button
          type="submit"
          className={styles.correctButton}
          variant="default"
        >
          {I18n.t(
            'templates.activities.distance_correction.correct_distance_revert'
          )}
        </Button>
      </div>
    );

  const CorrectDistanceModal = (
    <Modal isOpen={isModalOpen} onDismiss={toggleModalOpen} hasClose={true}>
      <div className={styles.modalHeader}>
        {I18n.t('templates.activities.distance_correction.distance_help')}
      </div>
      <form
        action={`/activities/${activityId}/swap_distance_stream?to_source=${
          activeSource === 'device' ? 'synthetic' : 'device'
        }`}
        method="post"
      >
        <input type="hidden" name="authenticity_token" value={csrfToken()} />

        {modalContents}
      </form>
    </Modal>
  );

  return (
    <>
      {
        // This is needed in order to make the link match all the others in the rails side menu
        // TODO this should be changed to a sidebar of buttons for accesibility once moved out of rails
      }
      {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
      <a href="#" onClick={toggleModalOpen}>
        {activeSource === 'device'
          ? I18n.t('templates.activities.distance_correction.correct_distance')
          : I18n.t(
              'templates.activities.distance_correction.correct_distance_revert'
            )}
      </a>
      {CorrectDistanceModal}
    </>
  );
};

CorrectDistance.propTypes = {
  activityId: PropTypes.number.isRequired,
  activeSource: PropTypes.string.isRequired
};

export default CorrectDistance;
